/**
 * Truncates a wallet address into the `1234…abcd` display form used
 * across Wallet and Shop. `head` / `tail` default to 4 chars each.
 *
 * Intentionally does no validation — callers are expected to gate on
 * `address` being non-empty before formatting.
 */
export const formatWalletAddress = (
  address: string,
  head: number = 4,
  tail: number = 4
): string => {
  if (address.length <= head + tail) return address
  return `${address.slice(0, head)}…${address.slice(-tail)}`
}
